module.exports = __webpack_public_path__ + "img/inactive-user-img.f7743c20.svg";